import request from '@/utils/request'
// 公告列表
export function noticeList(data) {
  return request({
    url: 'sys/notice/list',
    method: 'post',
    data
  })
}
// 修改搞
export function noticeUpdate(data) {
  return request({
    url: '/sys/notice/update',
    method: 'post',
    data
  })
}